import { Grid, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useUserSettings } from '../../../../../hooks'
import { Spacer } from '../../../../Spacer'
import { ReservationFormData } from '../constants'
import { Items } from './Items'
import { TimeSlotsSkeleton } from './TimeSlotsSkeleton'
import { MergedAvailabilities } from '../../../../../types/mergedAvailabilities'
import { useTranslation } from 'react-i18next'

interface Props {
  availabilities: MergedAvailabilities
  isLoading?: boolean
}

const Time = ({ availabilities, isLoading = false }: Props) => {
  const { locale } = useUserSettings()
  const { watch } = useFormContext<ReservationFormData>()

  const [dateStart, timezone, clientStartDate] = watch(['dateStart', 'timezone', 'clientStartDate'] as const)

  useEffect(() => {
    if (!clientStartDate || dateStart) {
      return
    }
  }, [clientStartDate, dateStart])

  const hasSelectedADay = Boolean(clientStartDate)

  const dateOptions: Intl.DateTimeFormatOptions = {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
  }

  const formattedDate = clientStartDate ? clientStartDate?.toLocaleDateString(locale, dateOptions) : ''

  const DateTitle = () => {
    return (
      <Typography variant="h3" sx={{ pt: '0.25rem' }}>
        {formattedDate}
      </Typography>
    )
  }

  const HelperTitle = () => {
    const { t } = useTranslation()
    return (
      <Typography variant={'h3'} sx={{ pt: '0.25rem' }}>
        {t('common.label.pleaseSelectDay')}
      </Typography>
    )
  }

  return (
    <Grid container spacing={3} sx={{ p: 0 }}>
      <Grid data-availabilities item xs={12}>
        <div>{hasSelectedADay ? <DateTitle /> : <HelperTitle />}</div>
        <Spacer />

        {hasSelectedADay && (
          <>
            {isLoading ? <TimeSlotsSkeleton /> : <Items availabilities={availabilities} dateStart={clientStartDate} timezone={timezone} />}
          </>
        )}
      </Grid>
    </Grid>
  )
}

export { Time }
